@if (item(); as item) {
  <procure-card
    class="detail-container"
    flat
  >
    @if (item.hierarchy?.length) {
      <div class="hierarchy">
        @for (element of item.hierarchy; track element.entity_number) {
          <procure-search-entity-badge
            [item]="element"
            [label]="element.name"
          />
        }
      </div>
    }
    <h3 class="name">{{ item.name }}</h3>
    @if (isResultItem(item) && metadataItems().length) {
      <table class="table">
        <tbody>
          @for (meta of metadataItems(); track meta) {
            @if (item.metadata?.[meta]; as value) {
              <tr>
                <td class="table-cell">{{ meta }}</td>
                <td class="table-cell">
                  @if (value.type === "boolean" && isBoolean(value.value)) {
                    <procure-checkbox
                      disabled
                      condensed
                      [checked]="value.value"
                    />
                  } @else if (value.type === "date") {
                    {{ value.value | date }}
                  } @else if (value.type === "person" && isMetadataUser(value.value)) {
                    <procure-person [user]="{ id: 0, name: value.value.name, avatarUrl: value.value.avatar_url }" />
                  } @else {
                    {{ value.value }}
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  </procure-card>
}
